import React, { useEffect, useRef, useState } from "react";
import Layouts from "../Components/Layouts";

import Conclave from "../Assests/Activities/Conclave.jpg";
import HC_T_nagar from "../Assests/Activities/Health Camp-T. Nagar.jpg";
import HC_Alwarpet from "../Assests/Activities/Health Camp – Alwarpet.jpg";
import HC_ECR from "../Assests/Activities/Health Camp –ECR.jpg";
import HC_MylaporeClub from "../Assests/Activities/Health Camp – Mylapore Club.jpg";
import HC_University from "../Assests/Activities/Health Camp – University of Madras.png";
import Swarnaprashana from "../Assests/Activities/Swarnaprashana.jpg";
import Stakeholders from "../Assests/Activities/Stakeholders.jpg";
import mouImage from "../Assests/Activities/MoU.jpg";

const activitiesData = [
  {
    date: "9–10 January 2026",
    activity: "International Ayurveda Conclave – Manapakkam",
    details:
      "Conducted a health camp and showcased our Ayurvedic products. Over 100 people benefited from the camp.",
    image: Conclave,
  },
  {
    date: "21 April 2026",
    activity: "MoU with SCSVMV",
    details:
      "Established an institutional collaboration with Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya (SCSVMV) for the supply of Ayurvedic medicines and research support.",
    image: mouImage,
  },
  {
    date: "2 May 2026",
    activity: "Ayurveda Health Camp – Stenographers Guild, T. Nagar",
    details:
      "Conducted a health camp, with over 100 people benefiting from free Ayurvedic consultation.",
    image: HC_T_nagar,
  },
  {
    date: "8–10 June 2026",
    activity:
      "Ayurveda Health Camp – Asthika Samajam, Venus Colony, Alwarpet",
    details:
      "Conducted a three-day health camp, with over 150 people benefiting from free Ayurvedic consultation.",
    image: HC_Alwarpet,
  },
  {
    date: "27–28 June 2026",
    activity: "Founder's Day Mega Health Camp – Mylapore Club",
    details:
      "Organised a mega health camp as part of the Founder's Day celebrations with over 150 people benefiting.",
    image: HC_MylaporeClub,
  },
  {
    date: "15 July 2026",
    activity: "Swarnaprashana Programme Launch",
    details:
      "Launched the Swarnaprashana Programme at the dispensary in the presence of the Honourable Minister for Food and Civil Supplies, Thiru. Venkataramanan.",
    image: Swarnaprashana,
  },
  {
    date: "24 July 2026",
    activity: "Ayurveda Health Camp – Jagannath Temple, ECR",
    details:
      "Conducted a health camp with over 50 people benefiting from free Ayurvedic consultation.",
    image: HC_ECR,
  },
  {
    date: "4 August 2026",
    activity: "TN-RISE Stakeholders Meeting",
    details:
      "Managing Trustee Shyam Swaminathan Raghunandan presented the institution's activities, achievements and vision for future collaborations to TN-RISE stakeholders meeting.",
    image: Stakeholders,
  },
  {
    date: "5 August 2026",
    activity: "Founder's Day Mega Health Camp – University of Madras",
    details:
      "Conducted a health camp at the University of Madras, with over 200 people benefiting from free Ayurvedic consultation.",
    image: HC_University,
  },
];

export default function ActivitiesPage() {
  const scrollRef = useRef(null);
  const autoScrollRef = useRef(null);

  const [isPaused, setIsPaused] = useState(false);

  /* ============================================================
     AUTO SCROLL
  ============================================================ */

  useEffect(() => {
    const container = scrollRef.current;

    if (!container) return;

    const startAutoScroll = () => {
      autoScrollRef.current = setInterval(() => {
        if (!isPaused && container) {
          const maxScroll = container.scrollWidth - container.clientWidth;

          if (container.scrollLeft >= maxScroll - 5) {
            container.scrollTo({
              left: 0,
              behavior: "smooth",
            });
          } else {
            container.scrollBy({
              left: 380,
              behavior: "smooth",
            });
          }
        }
      }, 3500);
    };

    startAutoScroll();

    return () => {
      clearInterval(autoScrollRef.current);
    };
  }, [isPaused]);

  /* ============================================================
     MANUAL SCROLL
  ============================================================ */

  const scrollNext = () => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: 400,
      behavior: "smooth",
    });
  };

  const scrollPrevious = () => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: -400,
      behavior: "smooth",
    });
  };

  return (
    <Layouts>
      <main className="min-h-screen bg-[#FAF8F3] overflow-hidden">

        {/* =====================================================
            HERO
        ====================================================== */}

        <section className="relative bg-[#FFF1C7] border-b border-[#E5D39C] overflow-hidden">

          {/* Decorative circles */}
          <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full border border-[#D5B96A] opacity-40" />

          <div className="absolute -bottom-32 -right-20 w-80 h-80 rounded-full border border-[#D5B96A] opacity-40" />

          <div className="relative max-w-7xl mx-auto px-5 sm:px-4 lg:px-6 py-7 sm:py-8 md:py-10">

            <div className="max-w-4xl mx-auto text-center">

              <span className="inline-block text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-[#8B6B35]">
                Our Journey • Our Service • Our Legacy
              </span>

              <h1 className="mt-4 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-[#5C3A21] leading-tight">
                Institutional Activities
              </h1>

              <div className="flex items-center justify-center gap-3 mt-6">
                <div className="w-12 sm:w-20 h-[2px] bg-[#C79A45]" />

                <div className="w-3 h-3 rotate-45 bg-[#C79A45]" />

                <div className="w-12 sm:w-20 h-[2px] bg-[#C79A45]" />
              </div>

              <p className="mt-6 text-sm sm:text-base md:text-lg text-gray-700 leading-7 sm:leading-8 max-w-2xl mx-auto">
                Discover our health camps, community initiatives,
                collaborations and milestones that continue our commitment
                to Ayurveda and public service.
              </p>

            </div>
          </div>
        </section>


        {/* =====================================================
            ACTIVITY SECTION
        ====================================================== */}

        <section className="relative py-6 sm:py-12 md:py-16">
          <div className="max-w-[1600px] mx-auto">
            {/* Section heading */}
            <div className="px-5 sm:px-8 lg:px-12 mb-10 md:mb-14">
              <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                <div>
                  <span className="text-xs sm:text-sm font-semibold tracking-[0.3em] uppercase text-[#A17A36]">
                    2026 Highlights
                  </span>
                  <h2 className="mt-2 text-2xl sm:text-3xl md:text-4xl font-serif font-bold text-[#4E321F]">
                    Our Recent Activities
                  </h2>
                  <div className="flex items-center gap-3 mt-4">
                    <div className="w-14 h-[3px] bg-[#C79A45]" />
                    <div className="w-2 h-2 rounded-full bg-[#C79A45]" />
                  </div>
                </div>
                {/* Navigation buttons */}
                <div className="flex gap-3">
                  <button
                    onClick={scrollPrevious}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    className=" w-11 h-11 sm:w-12 sm:h-12 rounded-full border border-[#D9C58E] bg-white text-[#6D4B24] flex items-center justify-center shadow-sm hover:bg-[#FFF1C7] hover:shadow-md transition-all duration-300"
                    aria-label="Previous activities"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </button>

                  <button
                    onClick={scrollNext}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                    className="
                      w-11 h-11
                      sm:w-12 sm:h-12
                      rounded-full
                      bg-[#5C3A21]
                      text-white
                      flex items-center justify-center
                      shadow-md
                      hover:bg-[#74492A]
                      hover:shadow-lg
                      transition-all duration-300
                    "
                    aria-label="Next activities"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>

                </div>

              </div>
            </div>


            {/* =================================================
                HORIZONTAL TIMELINE
            ================================================== */}

            <div className="relative">

              {/* Timeline line */}

              <div className="
                hidden sm:block
                absolute
                top-[21px]
                left-0
                right-0
                h-[1px]
                bg-[#D8C48B]
                opacity-60
              " />

              <div
                ref={scrollRef}
                onMouseEnter={() => setIsPaused(true)}
                onMouseLeave={() => setIsPaused(false)}
                onTouchStart={() => setIsPaused(true)}
                onTouchEnd={() => {
                  setTimeout(() => setIsPaused(false), 2000);
                }}
                className="
                  flex
                  gap-5
                  sm:gap-6
                  lg:gap-8
                  overflow-x-auto
                  px-5
                  sm:px-8
                  lg:px-12
                  pb-8
                  snap-x
                  snap-mandatory
                  scroll-smooth
                  scrollbar-hide
                "
                style={{
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >

                {activitiesData.map((item, index) => (

                  <article
                    key={index}
                    className="
                      group
                      flex-none
                      w-[86vw]
                      sm:w-[55vw]
                      md:w-[42vw]
                      lg:w-[360px]
                      xl:w-[390px]
                      snap-start
                      relative
                      pt-8
                      animate-[fadeInUp_0.7s_ease-out_both]
                    "
                    style={{
                      animationDelay: `${index * 100}ms`,
                    }}
                  >

                    {/* Timeline dot */}

                    <div className="
                      hidden sm:flex
                      absolute
                      top-0
                      left-6
                      w-10
                      h-10
                      rounded-full
                      bg-[#FFF1C7]
                      border-4
                      border-[#FAF8F3]
                      shadow-md
                      items-center
                      justify-center
                      z-20
                    ">
                      <div className="
                        w-3
                        h-3
                        rounded-full
                        bg-[#A17A36]
                        group-hover:scale-125
                        transition-transform
                        duration-300
                      " />
                    </div>


                    {/* CARD */}

                    <div className="
                      h-full
                      bg-white
                      rounded-[1.5rem]
                      overflow-hidden
                      border border-[#E9DFCC]
                      shadow-[0_10px_35px_rgba(92,58,33,0.08)]
                      hover:shadow-[0_20px_50px_rgba(92,58,33,0.15)]
                      hover:-translate-y-2
                      transition-all
                      duration-500
                    ">

                      {/* IMAGE */}

                      <div className="
                        relative
                        h-[230px]
                        sm:h-[250px]
                        md:h-[260px]
                        overflow-hidden
                        bg-[#F2EDE3]
                      ">

                        <img
                          src={item.image}
                          alt={item.activity}
                          loading="lazy"
                          className="
                            w-full
                            h-full
                            object-cover
                            transition-transform
                            duration-700
                            group-hover:scale-110
                          "
                        />

                        {/* Image overlay */}

                        <div className="
                          absolute
                          inset-0
                          bg-gradient-to-t
                          from-black/50
                          via-transparent
                          to-transparent
                          opacity-70
                        " />

                        {/* Activity number */}

                        <div className="
                          absolute
                          top-4
                          left-4
                          w-10
                          h-10
                          rounded-full
                          bg-white/95
                          backdrop-blur
                          flex
                          items-center
                          justify-center
                          shadow-md
                        ">
                          <span className="text-sm font-bold text-[#6D4B24]">
                            {String(index + 1).padStart(2, "0")}
                          </span>
                        </div>

                        {/* Date */}

                        <div className="
                          absolute
                          bottom-4
                          left-4
                          right-4
                        ">

                          <span className="
                            inline-flex
                            items-center
                            px-3
                            py-1.5
                            rounded-full
                            bg-[#FFF1C7]
                            text-[#6D4B24]
                            text-xs
                            sm:text-sm
                            font-bold
                            shadow-md
                          ">
                            {item.date}
                          </span>

                        </div>

                      </div>


                      {/* CONTENT */}

                      <div className="p-5 sm:p-6">

                        <h3 className="
                          text-lg
                          sm:text-xl
                          font-serif
                          font-bold
                          text-[#4E321F]
                          leading-snug
                          group-hover:text-[#8B6B35]
                          transition-colors
                          duration-300
                        ">
                          {item.activity}
                        </h3>

                        <div className="flex items-center gap-2 mt-4">

                          <div className="w-10 h-[2px] bg-[#C79A45]" />

                          <div className="w-1.5 h-1.5 rounded-full bg-[#C79A45]" />

                        </div>

                        <p className="
                          mt-4
                          text-sm
                          sm:text-[15px]
                          text-gray-600
                          leading-7
                        ">
                          {item.details}
                        </p>

                      </div>

                    </div>

                  </article>

                ))}

              </div>

            </div>


            {/* Scroll hint */}

            <div className="flex justify-center mt-3 px-5">

              <div className="
                flex
                items-center
                gap-2
                text-xs
                sm:text-sm
                text-gray-500
              ">

                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>

                <span>
                  Swipe or use the arrows to explore our activities
                </span>

              </div>

            </div>

          </div>

        </section>


        {/* =====================================================
            FOOTER MESSAGE
        ====================================================== */}

        <section className="bg-[#5C3A21] relative overflow-hidden">

          <div className="
            absolute
            -top-32
            -left-32
            w-72
            h-72
            rounded-full
            border
            border-[#D8BD73]
            opacity-20
          " />

          <div className="
            absolute
            -bottom-40
            -right-32
            w-96
            h-96
            rounded-full
            border
            border-[#D8BD73]
            opacity-20
          " />

          <div className="
            relative
            max-w-4xl
            mx-auto
            px-5
            sm:px-8
            py-14
            sm:py-16
            md:py-20
            text-center
          ">

            <span className="
              text-xs
              sm:text-sm
              tracking-[0.3em]
              uppercase
              text-[#E5C978]
              font-semibold
            ">
              Our Commitment
            </span>

            <h2 className="
              mt-4
              text-2xl
              sm:text-3xl
              md:text-4xl
              font-serif
              font-bold
              text-white
            ">
              Serving Society Through Ayurveda
            </h2>

            <p className="
              mt-5
              text-sm
              sm:text-base
              text-[#E9DDC7]
              leading-7
              max-w-2xl
              mx-auto
            ">
              Through health camps, education, collaboration and community
              initiatives, we continue to carry forward our institution's
              commitment to accessible and compassionate Ayurvedic healthcare.
            </p>

          </div>

        </section>

      </main>
    </Layouts>
  );
}